module.exports = __webpack_public_path__ + "static/media/5page_02.ee1abdf8.jpg";